<template>
  <div class="page-main">
    <div class="flex flex-y-center flex-x-between m-b-10">
      <div class="flex flex-y-center">
        <span class="c-gray">库存为只读视图，出入库数量由已审核的入库单/出库单驱动。</span>
        <!-- 一键清空所有表头筛选 -->
        <el-button
          size="mini"
          icon="el-icon-refresh"
          class="m-l-10"
          :disabled="!hasFilter"
          @click="resetFilter"
          >重置筛选
        </el-button>
      </div>
    </div>
    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 36 - 100"
      @resizable-change="handleColumnResize"
    >
      <!-- slot_header 表头筛选 -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          :value="filterData[column.field]"
          placeholder="输入关键字"
          @change="headerFilterChange"
        />
      </template>
      <!-- slot_default -->
      <template #default_qty="{ row }">
        <span class="c-orange">{{ row.qty }}</span>
      </template>
      <template #default_operate="{ row }">
        <el-button type="text" size="mini" @click="itemWater(row)">流水</el-button>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-库存流水 -->
    <PopupWater
      v-if="isShowPopupWater"
      :show.sync="isShowPopupWater"
      :cond="activeCond"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_stock_inventory_list',
  components: {
    PopupWater: () => import('./popup-water')
  },
  data() {
    return {
      loading: true,
      filterData: {
        warehouse_name: '',
        location_name: '',
        material_name: '',
        category: '',
        spec: '',
        unit: '',
        qty: '',
        batch_no: ''
      },
      sortData: {
        updated_at: 'desc'
      },
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      isShowPopupWater: false,
      activeCond: {}
    }
  },
  computed: {
    hasFilter() {
      return Object.keys(this.filterData).some((key) => {
        let val = this.filterData[key]
        return val !== '' && val !== null && val !== undefined
      })
    },
    headerFilterUrl() {
      return '/admin/gcvip/inventory/searchHeard'
    },
    tableColumn() {
      let result = [
        { fixed: 'left', title: '序号', type: 'seq', width: 40 },
        { title: '仓库', field: 'warehouse_name', slots: { header: 'header_input' }, width: 120 },
        { title: '仓位', field: 'location_name', slots: { header: 'header_input' }, width: 100 },
        { title: '物料名称', field: 'material_name', slots: { header: 'header_input' } },
        { title: '材质', field: 'category', slots: { header: 'header_input' }, width: 90 },
        { title: '规格(mm)', field: 'spec', slots: { header: 'header_input' }, width: 120 },
        { title: '单位', field: 'unit', slots: { header: 'header_input' }, width: 60 },
        { title: '数量', field: 'qty', slots: { header: 'header_input', default: 'default_qty' }, width: 90 },
        { title: '批号', field: 'batch_no', slots: { header: 'header_input' }, width: 120 },
        { title: '更新时间', field: 'updated_at', width: 150 },
        {
          fixed: 'right',
          title: '操作',
          field: 'operate',
          slots: { default: 'default_operate' },
          width: 70
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    resetFilter() {
      Object.keys(this.filterData).forEach((key) => {
        this.filterData[key] = ''
      })
      this.searchListData()
    },
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        filterData: this.filterData,
        sortData: this.$util.deepCopy(this.sortData)
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/inventory/stocklist',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = this.$util.deepCopy(data.list) || []
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    itemWater(row) {
      this.activeCond = {
        warehouseId: row.warehouse_id,
        locationId: row.location_id,
        skuId: row.sku_id,
        material_name: row.material_name,
        category: row.category,
        spec: row.spec,
        batch_no: row.batch_no
      }
      this.isShowPopupWater = true
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
